import type {ErrorEvent} from '@sentry/types';

function ignoreStageErrors(event: ErrorEvent): ErrorEvent | null {
  return event.request?.url?.includes('/tzlvt/tst/') ? null : event;
}

export const filterEvents = ignoreStageErrors;
